// Added by Sejune Oh on 2019-04-12
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Theme } from '@material-ui/core'
import { Property } from 'csstype'
import { MGMT_FORM_MIN_WIDTH, MGMT_FORM_MAX_WIDTH, BG_GREY, GREY_COLOR } from '../Theme'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const styles = (theme: Theme) => ({
    BtnOuterWrapper: {
        display: 'flex',
        width: '100%',
        padding: `${theme.spacing() * 2}px ${theme.spacing()}px`,
        paddingLeft: `30%`,
        boxSizing: 'border-box' as Property.BoxSizing,
        '@media (max-width: 990px)': {
            padding: `${theme.spacing()}px 0`,
        },
    },
    BtnWrapperDivider: {
        '&:before': {
            content: '""' as Property.Content,
            position: 'absolute' as Property.Position,
            left: '10vw',
            right: '10vw',
            borderBottom: `3px solid ${GREY_COLOR}`,
        },
        '@media (max-width: 1450px)': {
            position: 'relative' as Property.Position,
            '&:before': {
                left: '0',
                right: '0',
            },
        },
    },
    BtnInnerWrapper: {
        display: 'flex',
        flex: 1,
        justifyContent: 'space-between',
        paddingLeft: `${theme.spacing()}px`,
    },
    BtnCtrWrapper: {},
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    MgmtFormPaper: {
        display: 'flex',
        flexDirection: 'column' as Property.FlexDirection,
        alignSelf: 'center' as Property.AlignSelf,
        minWidth: `${MGMT_FORM_MIN_WIDTH}px`,
        maxWidth: `${MGMT_FORM_MAX_WIDTH}px`,
        width: '100%',
        position: 'relative' as Property.Position,
        transition: 'opacity 0.15s ease-out' as Property.Transition,
    },
    MgmtFormPaperWide: {
        width: '100%',
    },
    MgmtFormUnmountedPaper: {
        opacity: 0.1,
    },
    MgmtFormMountedPaper: {
        opacity: 1,
    },
    MgmtFormHeader: {},
    MgmtFormHeaderWrapper: {
        display: 'flex' as Property.Display,
        justifyContent: 'space-between' as Property.JustifyContent,
        alignItems: 'center' as Property.AlignItems,
        padding: `${theme.spacing()}px ${theme.spacing() * 2}px`,
        background: `${BG_GREY}`,
        zIndex: 1,
    },
    MgmtFormWrapper: {
        marginBottom: `${2 * theme.spacing()}px`,
    },
    MgmtFormBtnWrapper: {
        paddingTop: `${theme.spacing() * 3}px`,
    },
    MgmtFormBtn: {
        marginRight: `${theme.spacing()}px`,
        '&:last-child': {
            marginRight: 0,
        },
    },
    MgmtFormRemoveBtn: {
        position: 'absolute' as Property.Position,
        left: '0',
    },
    MgmtFormNoti: {
        maxWidth: '100%',
        backgroundColor: theme.palette.error.main as Property.BackgroundColor,
        color: theme.palette.error.contrastText as Property.Color,
    },
    MgmtFormNotiWrapper: {
        position: 'absolute' as Property.Position,
        bottom: -52,
        width: '100%',
    },
})

export default styles
